/** Tránh tích participant-minute Daily khi treo máy / không tương tác trang. Override bằng VITE_*. */
function parsePositiveMinutes(raw: string | undefined, fallback: number): number {
  const n = Number(raw)
  if (!Number.isFinite(n) || n <= 0) return fallback
  return Math.min(n, 24 * 60)
}

const warnMin = parsePositiveMinutes(import.meta.env.VITE_COURTROOM_IDLE_WARN_MINUTES, 15)
const graceMin = parsePositiveMinutes(import.meta.env.VITE_COURTROOM_IDLE_GRACE_MINUTES, 3)

export const COURTROOM_IDLE_MS = {
  warnAfterMs: warnMin * 60 * 1000,
  graceAfterWarnMs: graceMin * 60 * 1000,
}
